{
  "appName": "VynaEMR",
  "appTagline": "Rekam Medis Elektronik Berfokus APAC",
  "developedByLabel": "Dikembangkan oleh",
  "loading": "Memuat...",
  "save": "Simpan",
  "cancel": "Batal",
  "delete": "Hapus",
  "edit": "Ubah",
  "create": "Buat",
  "search": "Cari",
  "filter": "Filter",
  "actions": "Tindakan",
  "confirm": "Konfirmasi",
  "back": "Kembali",
  "next": "Berikutnya",
  "previous": "Sebelumnya",
  "submit": "Kirim",
  "reset": "Atur Ulang",
  "close": "Tutup",
  "yes": "Ya",
  "no": "Tidak",
  "ok": "OK",
  "error": "Kesalahan",
  "success": "Berhasil",
  "warning": "Peringatan",
  "info": "Informasi",
  "validation": {
    "required": "Kolom ini wajib diisi",
    "invalidEmail": "Alamat email tidak valid",
    "invalidPhone": "Nomor telepon tidak valid",
    "invalidDate": "Tanggal tidak valid",
    "minLength": "Minimal {{min}} karakter diperlukan",
    "maxLength": "Maksimal {{max}} karakter diperbolehkan",
    "passwordMismatch": "Kata sandi tidak cocok"
  },
  "form": {
    "fieldRequired": "{{field}} wajib diisi",
    "selectOption": "Silakan pilih salah satu opsi",
    "discardConfirm": "Buang perubahan yang belum disimpan?",
    "unsavedChanges": "Anda memiliki perubahan yang belum disimpan",
    "mustBeNonNegativeInteger": "{{field}} harus berupa bilangan bulat (0 atau lebih)",
    "mustBeNonNegativeNumber": "{{field}} harus berupa angka (0 atau lebih)"
  },
  "unsavedChanges": {
    "title": "Perubahan Belum Disimpan",
    "body": "Anda memiliki perubahan yang belum disimpan. Yakin ingin meninggalkan halaman ini? Perubahan akan hilang.",
    "stay": "Tetap di sini",
    "leave": "Tinggalkan"
  },
  "messages": {
    "saveSuccess": "Perubahan berhasil disimpan",
    "saveError": "Gagal menyimpan perubahan",
    "deleteConfirm": "Apakah Anda yakin ingin menghapus item ini?",
    "deleteSuccess": "Item berhasil dihapus",
    "deleteError": "Gagal menghapus item",
    "networkError": "Kesalahan jaringan. Silakan periksa koneksi Anda.",
    "serverError": "Kesalahan server. Silakan coba lagi nanti.",
    "unauthorized": "Anda tidak memiliki izin untuk melakukan tindakan ini."
  },
  "dateFormat": {
    "short": "DD/MM/YYYY",
    "long": "D MMMM YYYY",
    "withTime": "DD/MM/YYYY HH:mm",
    "timeOnly": "HH:mm"
  },
  "demo": {
    "warning": "Ini adalah demo VynaEMR — jangan masukkan informasi pasien sebenarnya (PHI)."
  },
  "network": {
    "offline": "Anda sedang offline. Data klinis mungkin tidak tersimpan."
  },
  "permissionDenied": {
    "title": "Akses Ditolak",
    "body": "Anda tidak memiliki izin untuk {{action}}.",
    "genericBody": "Anda tidak memiliki izin untuk melihat sumber daya ini.",
    "requiredPermission": "Izin yang diperlukan: {{name}}",
    "contactAdmin": "Jika Anda yakin ini adalah kesalahan, silakan hubungi administrator sistem Anda.",
    "requiresPermissionCode": "Memerlukan izin: {{code}}",
    "requiresLabel": "Memerlukan {{label}}",
    "requiresLabelWithRoles": "Memerlukan {{label}} (dipegang oleh: {{roles}})",
    "insufficient": "Izin tidak cukup"
  },
  "skipToContent": "Lewati ke konten",
  "openMenu": "Buka menu",
  "topBar": {
    "searchPlaceholder": "Cari pasien (MRN, nama, ID)...",
    "recentPatients": "Pasien Terbaru",
    "searching": "Mencari...",
    "noPatientsFound": "Pasien tidak ditemukan. Tekan Enter untuk mencari.",
    "notifications": "Notifikasi",
    "selectFacility": "Pilih fasilitas",
    "allFacilities": "Semua Fasilitas",
    "facilityLabel": "Fasilitas {{id}}",
    "activeDepartment": "Bertugas di",
    "selectDepartment": "Pilih departemen kerja",
    "noDepartmentSelected": "Pilih departemen",
    "departmentLabel": "Departemen {{id}}",
    "departmentSwitchFailed": "Gagal mengalihkan"
  },
  "theme": {
    "toggle": "Ganti tema",
    "light": "Terang",
    "dark": "Gelap",
    "system": "Sistem",
    "current": "Tema: {{name}}"
  },
  "appVersionLabel": "VynaEMR v{{version}}",
  "footerCopyright": "© {{year}}",
  "footerHealthOperational": "Beroperasi",
  "footerHealthIssue": "Gangguan koneksi",
  "dobLabel": "Tgl Lahir {{date}}",
  "pagination": {
    "previous": "Sebelumnya",
    "next": "Berikutnya",
    "pageOf": "Halaman {{current}} dari {{total}}",
    "showing": "Menampilkan {{from}} sampai {{to}} dari {{total}}",
    "loadMore": "Muat lebih banyak"
  },
  "table": {
    "empty": "Tidak ada data",
    "loading": "Memuat..."
  },
  "cdsAlert": {
    "severity": {
      "info": "Info",
      "warning": "Peringatan",
      "critical": "Kritis"
    },
    "overridden": "Ditimpa",
    "acknowledged": "Dikonfirmasi",
    "justificationPlaceholder": "Masukkan alasan justifikasi...",
    "submit": "Kirim",
    "acknowledge": "Konfirmasi",
    "override": "Timpa",
    "regionAria": "Peringatan dukungan keputusan klinis (CDS)",
    "acknowledgeFailed": "Tidak dapat mencatat konfirmasi — tidak tersimpan. Silakan coba lagi.",
    "overrideFailed": "Tidak dapat mencatat penimpaan — tidak tersimpan. Silakan coba lagi.",
    "addressedCount_one": "{{count}} ditangani",
    "addressedCount_other": "{{count}} ditangani"
  },
  "components": {
    "printButton": {
      "defaultLabel": "Cetak"
    },
    "codeSearch": {
      "searchPlaceholder": "Cari kode...",
      "clearAriaLabel": "Hapus pilihan",
      "noCodesFound": "Kode tidak ditemukan"
    },
    "demographicPicker": {
      "addPlaceholder": "Tambah…",
      "loading": "Memuat…",
      "noneRecorded": "Tidak tercatat",
      "removeAriaLabel": "Hapus {{value}}",
      "unavailable": "Daftar nilai tidak tersedia",
      "unavailableHint": "Daftar nilai tidak dapat dimuat. Nilai yang ada tetap tidak berubah dan akan tetap disimpan.",
      "uncodedBadge": "tanpa kode",
      "uncodedTitle": "Dicatat sebelum nilai berkode ada. Nilai ini dapat dihapus, tetapi tidak dapat ditambahkan kembali."
    }
  },
  "pages": {
    "accessDenied": {
      "title": "Akses Ditolak",
      "httpStatus": "HTTP 403",
      "body": "Anda tidak memiliki izin untuk melihat halaman ini.",
      "attemptedLabel": "Mencoba mengakses:",
      "requiredPermissionLabel": "Izin yang diperlukan:",
      "typicallyHeldByLabel": "Biasanya dimiliki oleh:",
      "signedInAs": "Masuk sebagai",
      "contactAdminHelp": "Jika Anda yakin ini adalah kesalahan, silakan hubungi administrator sistem atau kepala departemen untuk meminta peran yang diperlukan.",
      "goBack": "Kembali",
      "dashboard": "Dasbor",
      "contact": "Kontak"
    },
    "notificationInbox": {
      "title": "Notifikasi",
      "markAllRead": "Tandai Semua Telah Dibaca",
      "loading": "Memuat notifikasi…",
      "errorState": "Gagal memuat notifikasi.",
      "emptyState": "Tidak ada notifikasi.",
      "ariaFilterStatus": "Saring berdasarkan status",
      "ariaFilterPriority": "Saring berdasarkan prioritas",
      "ariaFilterType": "Saring berdasarkan tipe",
      "filterStatus": {
        "all": "Semua",
        "unread": "Belum Dibaca",
        "read": "Telah Dibaca"
      },
      "filterPriority": {
        "allLabel": "Semua Prioritas",
        "critical": "Kritis",
        "high": "Tinggi",
        "normal": "Normal",
        "low": "Rendah"
      },
      "filterType": {
        "allLabel": "Semua Tipe"
      },
      "notificationType": {
        "criticalResult": "Hasil Kritis",
        "orderUpdate": "Pembaruan Order",
        "appointmentReminder": "Pengingat Janji Temu",
        "systemAlert": "Peringatan Sistem",
        "cdsAlert": "Peringatan Dukungan Keputusan Klinis",
        "result": "Hasil Pemeriksaan",
        "handoffAssigned": "Serah terima"
      },
      "toasts": {
        "allMarkedRead": "Semua notifikasi ditandai telah dibaca",
        "markAllReadFailed": "Gagal menandai semua notifikasi telah dibaca",
        "markReadFailed": "Gagal menandai notifikasi telah dibaca"
      }
    },
    "entityResolver": {
      "invalidId": "Tautan tidak valid.",
      "notFound": "Tidak ditemukan, atau Anda tidak memiliki akses."
    }
  },
  "license": {
    "evalBanner": "Evaluation license: {{count}} days left.",
    "graceBanner": "License issue: service continues for {{count}} more hours.",
    "expiringBanner": "License expires soon: {{count}} days left. Renew now to avoid service refusal.",
    "saasUnkeyedBanner": "Organization license not installed. Premium modules are open during rollout.",
    "saasUnverifiableBanner": "Organization license cannot be verified. Premium modules are open; contact support.",
    "expiredBanner": "License expired. Requests are being refused.",
    "invalidBanner": "License invalid. Requests are being refused.",
    "viewLicense": "View license"
  },
  "wsDown": {
    "title": "Pembaruan langsung tidak tersedia",
    "body": "Hasil dan peringatan baru tidak akan tiba otomatis hingga koneksi pulih.",
    "authBody": "Sesi Anda telah berakhir. Masuk kembali untuk memulihkan pembaruan langsung.",
    "retry": "Coba lagi",
    "login": "Masuk"
  }
}
